// extracted by css-extract-rspack-plugin
export default {"item":"UsersList_item__uGpPf","checkIcon":"UsersList_checkIcon__RXpSx"};